export const GET_PLUGINS = 'GET_PLUGINS';
export const GET_PLUGIN = 'GET_PLUGIN';
export const PLUGINS_LOADING = 'PLUGINS_LOADING';
export const PLUGINS_SUCCESS = 'PLUGINS_SUCCESS';
export const PLUGINS_ERROR = 'PLUGINS_ERROR';
export const RESET_PLUGINS_MSG = 'RESET_PLUGINS_MSG';
